const NOT_ON_SALE_TOKEN_IDS = [
  23,
  24,
  26,
  27,
  28,
  29,
  32,
  33,
  141,
  253,
  382,
  559,
  317, // 2022/05/20 ref: https://discord.com/channels/871910935843975168/872100998146056193/976718992217624617
];

export default NOT_ON_SALE_TOKEN_IDS;
